import React, { Component } from 'react';
import NikooClinicsTiming from './nikoo2timing';
import { Link } from 'react-router-dom';
export default class ClinicVisitBhartiyaCityNikoo2 extends Component {
  render() {
    return (
      <>
        <div className='Inner-banner'>
                <img className="img-fluid" src={`${process.env.PUBLIC_URL}/img/famphy-nikoo2-banner.jpg`} alt="Home Visits" />
              </div>
                <div className='clinic-visit'>
                    <NikooClinicsTiming />
                    <div className='services-item container'>
                            <div className='row'>
                              <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle mob-order-2 p-0'>
                                <div className='services-item-content'>
                                  <h2>Fam<span>Phy</span> Clinic</h2>          
                                  <h4>Ground Floor, Nikoo 2, Bhartiya City, Bengaluru, 560064, Karnatka</h4>
                                  <Link to="/contacts" className="btn theam-btn-m">Contact Us</Link>
                                </div>
                              </div>
                              <div className='col-lg-6 col-md-6 col-sm-12 mob-order-1 p-0'>
                              <img className="img-fluid" src={`${process.env.PUBLIC_URL}/img/famphy-nikoo2-img03.jpg`} alt="Home Visits" />
                              </div>
                            </div>
                          </div>
                    
                </div>
      </>
    );
  }
}
